__turbopack_context__.v({
  "bentoCard": "index-module__6l-qGW__bentoCard",
  "bentoGrid": "index-module__6l-qGW__bentoGrid",
  "root": "index-module__6l-qGW__root",
  "span-2": "index-module__6l-qGW__span-2",
});
